import React from 'react';
import { useTheme } from 'styled-components';
import { Assets } from "../../assets";
import { IconButtonContainer, IconWrapper, StyledClipLoader } from "./IconButton.styles";
import { jsx as _jsx } from "react/jsx-runtime";
const iconSizeMapper = compSize => {
  const map = {
    xs: 'sm',
    sm: 'md',
    md: 'lg',
    lg: 'lg'
  };
  return map[compSize ?? 'md'];
};

/**
 * A button with an icon.
 *
 * @param icon The icon to be displayed
 * @param color The color of the button
 * @param radius The radius of the button,which indicates whether it is square or round
 * @param size The size of the button
 * @param disabled If the button is disabled
 * @param loading If the button is loading
 * @param active If the button is active, to be used as an alternator. If null, it works like a normal button
 * @param onPress The function to be called when the button is pressed
 */
const IconButton = props => {
  const {
    icon,
    color,
    radius,
    size = 'md',
    disabled,
    loading,
    active,
    onClick,
    ...rest
  } = props;
  const theme = useTheme();
  const IconComp = icon && Assets[icon];
  const iconColor = loading ? theme?.colors?.neutralL4 : theme?.colors?.neutralL5;
  return /*#__PURE__*/_jsx(IconButtonContainer, {
    ...rest,
    type: "button",
    color: color,
    radius: radius,
    size: size,
    active: active,
    disabled: disabled,
    onClick: onClick,
    children: loading ? /*#__PURE__*/_jsx(StyledClipLoader, {
      size: iconSizeMapper(size),
      color: iconColor
    }) : IconComp && /*#__PURE__*/_jsx(IconWrapper, {
      children: /*#__PURE__*/_jsx(IconComp, {
        size: iconSizeMapper(size),
        color: iconColor
      })
    })
  });
};
export { IconButton };